import React, { useEffect, useMemo } from 'react';
import '../../Assets/Css/Settings.scss';
import { useNavigate } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { customStyle } from '../../Components/Style';
import { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import Table from '../../Components/Table';
import DatePicker from 'react-datepicker';
import Alert from '@mui/material/Alert';
import { FaCircleInfo } from 'react-icons/fa6';
import { FaEnvelopeOpenText } from 'react-icons/fa6';
import { PiClockCountdownFill } from 'react-icons/pi';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { HiBars3 } from 'react-icons/hi2';
import { Button, Modal } from 'react-bootstrap';
import { updateUsers } from '../../Services/Users/action';
import { deleteRecord } from '../../Services/Delete/action';
import { FaCamera } from 'react-icons/fa';
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper';
import ModulesList from '../../Assets/ModulesLiist';
import FeaturesList from '../../Assets/FeaturesList';
import Skeleton from 'react-loading-skeleton';

const Country = [
  { value: 'India', label: 'India' },
  { value: 'USA', label: 'USA' },
  { value: 'Japan', label: 'Japan' },
  { value: 'Canada', label: 'Canada' },
  { value: 'Qatar', label: 'Qatar' },
];

const Language = [
  { value: 'English', label: 'English' },
  { value: 'Hindi', label: 'Hindi' },
  { value: 'Gujarati', label: 'Gujarati' },
];

const namePrefix = [
  { value: '---', label: '---' },
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Miss', label: 'Miss' },
  { value: 'Dr.', label: 'Dr.' },
  { value: 'Sir', label: 'Sir' },
  { value: 'Madam', label: 'Madam' },
];

const Gender = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
];

const MaritalStatus = [
  { value: "Married", label: "Married" },
  { value: "Unmarried", label: "Unmarried" },
];

const Setting = (props) => {
  const initialCountry = Country.find(
    (option) => option.value === props?.user?.country
  );
  const initialLanguage = Language.find(
    (option) => option.value === props?.user?.language
  );
  const initialGender = Gender.find(
    (option) => option.value === props?.user?.gender
  );
  const [activeTab, setActiveTab] = useState('profile');
  const [activeSecurityTab, setactiveSecurityTab] = useState('TwoFactorAuthentication');
  const [active, setActive] = useState('Profile Settings');
  const [showModal, setShowModal] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [params, setParams] = useState({});
  const [country, setCountry] = useState(initialCountry || null);
  const [prefix, setNamePrefix] = useState('');
  const [language, setLanguage] = useState(initialLanguage || null);
  const [gender, setGender] = useState(initialGender || null);
  const [mobile, setMobile] = useState(props?.user?.mobile || '');
  const [dob, setDOB] = useState(props?.user?.date_of_birth || '');
  const [files, setFiles] = useState([]);
  const [inData, setInData] = useState([]);
  const [imagePreview, setImagePreview] = useState(props?.user?.profile_pic || null);
  const [name, setName] = useState(props?.user?.name || '');
  const [email, setEmail] = useState(props?.user?.email || '');
  const [password, setPassword] = useState('');
  const [slack_id, setSlackId] = useState(props?.user?.slack_id || '');
  const [address, setAddress] = useState(props?.user?.address || '');
  const [about, setAbout] = useState(props?.user?.about || '');
  // const [rtl, setRtl] = useState('');
  const [enable_google_calendar, setEnableGoogleCalendar] = useState(props?.user?.enable_google_calendar ? true : false);
  const [email_notifications, setEmailNotifications] = useState(props?.user?.email_notifications ? true : false);
  const [personalEmail, setPersonalEmail] = useState(props?.user?.personal_email || '');
  const navigate = useNavigate();
  const profilePic = localStorage.getItem("userProfilePic");
  const [searchTerm, setSearchTerm] = useState('');
  const [maritalStatus, setMaritalStatus] = useState(MaritalStatus?.find(item => item?.value == props?.user?.marital_status) || "");
  const [anniversary, setmrgAnniversary] = useState(props?.user?.marriage_anniversary_date || '');
  const [skills, setSkills] = useState(props?.user?.skills || '');
  const [permanent_address, setPermanentAddress] = useState(props?.user?.permanent_address || '');

  const initialValues = useMemo(() => ({
    // country: initialCountry?.value || '',
    // language: initialLanguage?.value || '',
    // gender: initialGender?.value || '',
    name: props?.user?.name || '',
    personal_email: props?.user?.personal_email || '',
    email: props?.user?.email || '',
    password: '',
    skills: props?.user?.skills || '',
    mobile: props?.user?.mobile || '',
    permanent_address: props?.user?.permanent_address || '',
    address: props?.user?.address || '',
    date_of_birth: props?.user?.date_of_birth || '',
    slack_id: props?.user?.slack_id || '',
    maritalStatus: props?.user?.marital_status || undefined,
    anniversary: props?.user?.marriage_anniversary_date || '',
    // about: props?.user?.about || '',
    // enable_google_calendar: props?.enable_google_calendar || false,
    // email_notifications: props?.email_notifications || false,
  }), [props?.user]);

  const isFormChanged = useMemo(() => {
    return (
      // initialValues.country !== country?.value ||
      // initialValues.language !== language?.value ||
      // initialValues.gender !== gender?.value ||
      initialValues.name !== name ||
      initialValues.personal_email !== personalEmail ||
      initialValues.email !== email ||
      initialValues.password !== password ||
      initialValues.skills !== skills ||
      initialValues.mobile !== mobile ||
      initialValues.permanent_address !== permanent_address ||
      initialValues.address !== address ||
      initialValues.date_of_birth !== dob ||
      initialValues.slack_id !== slack_id ||
      initialValues.maritalStatus !== maritalStatus?.value ||
      initialValues.anniversary !== anniversary ||
      // initialValues.about !== about ||
      // initialValues.enable_google_calendar !== enable_google_calendar ||
      // initialValues.email_notifications !== email_notifications ||
      files.length > 0
    );
  }, [
    name, personalEmail, email, password, skills, mobile, permanent_address, address, dob, slack_id, maritalStatus, anniversary, files
  ]);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [show, setShow] = useState(false);

  const closeOffcanvas = () => setShow(false);
  const showOffcanvas = () => setShow(true);

  const showToastMessage = (error) => {
    toast.error(error, {
      position: toast.POSITION.TOP_RIGHT,
    });
  };

  const header = [
    { field: 'Name' },
    { field: 'Email' },
    { field: 'Mobile' },
    { field: 'Relationship' },
    { field: 'Action' },
  ];


  let footer = true;
  let count = inData?.length;

  const handleFileChange = (event) => {
    const newFile = event.target.files[0];
    const fileSize = 2 * 1024 * 1024

    if (newFile) {
      if (newFile.size > fileSize) {
        toast.error("Image size must be 2MB or less.");
        event.target.value = null;
        return;
      }

      const reader = new FileReader();

      reader.onloadend = () => {
        const base64 = reader.result;
        setImagePreview(base64);
        localStorage.setItem("userProfilePic", base64);
        setFiles([newFile]);
      };

      reader.readAsDataURL(newFile);
    }
  };

  const handleSave = async () => {
    try {
      const file = files?.[0];

      const buildBodyAndUpdate = async (base64String = null) => {
        const body = {
          // country: country?.value,
          // language: language?.value,
          // gender: gender?.value,
          name,
          personal_email: personalEmail,
          email,
          password,
          skills,
          mobile,
          permanent_address,
          address,
          date_of_birth: dob,
          slack_id,
          marital_status: maritalStatus?.value,
          marriage_anniversary_date: anniversary
          // about,
          // rtl: rtl === "Yes",
          // enable_google_calendar: enable_google_calendar,
          // email_notifications: email_notifications,
        };

        if (base64String) {
          body.profile_pic = base64String;
        }

        body.updateLocalStorage = true;
        await props.updateUsers(props?.user?.id, body);
      };

      if (file) {
        const reader = new FileReader();

        reader.onloadend = async () => {
          const base64String = reader.result.split(",")[1];
          await buildBodyAndUpdate(base64String);
        };

        reader.readAsDataURL(file);
      } else {
        await buildBodyAndUpdate();
      }
    } catch (error) {
      console.error("Error in updating user: ", error);
    }
  };

  return (
    <div className="row">
      <div className="col-xl-3">
        <Offcanvas className="offcanvas-sidebar" show={show} onHide={closeOffcanvas}>
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div className="search-bar">
              <div className="input-group">
                <input type="text" className="input-css" name="search" placeholder="Search" value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)} />
              </div>
            </div>
            <ul className="menu-lists">
              {(!searchTerm || 'Profile Settings'.toLowerCase().replace(/\s+/g, '').includes(searchTerm.toLowerCase().trim().replace(/\s+/g, ''))) && (
                <li
                  className={`menu-items ${active === 'Profile Settings' ? 'active' : ''}`}
                  onClick={() => setActive('Profile Settings')}
                >
                  Profile Settings
                </li>
              )}
              {/* {(!searchTerm || 'Security Settings'.toLowerCase().replace(/\s+/g, '').includes(searchTerm.toLowerCase().trim().replace(/\s+/g, ''))) && (
                <li
                  className={`menu-items ${active === 'Security Settings' ? 'active' : ''}`}
                  onClick={() => setActive('Security Settings')}
                >
                  Security Settings
                </li>)} */}
            </ul>
          </Offcanvas.Body>
        </Offcanvas>

        <div className="sidebars">
          <div className="search-bar">
            <div className="input-group">
              <input type="text" className="input-css" name="search" placeholder="Search" value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} />
            </div>
          </div>
          <ul className="menu-lists">
            {(!searchTerm || 'Profile Settings'.toLowerCase().replace(/\s+/g, '').includes(searchTerm.toLowerCase().trim().replace(/\s+/g, ''))) && (

              <li
                className={`menu-items ${active === 'Profile Settings' ? 'active' : ''}`}
                onClick={() => setActive('Profile Settings')}
              >
                Profile Settings
              </li>
            )}
            {/* {(!searchTerm || 'Security Settings'.toLowerCase().replace(/\s+/g, '').includes(searchTerm.toLowerCase().trim().replace(/\s+/g, ''))) && (

              <li
                className={`menu-items ${active === 'Security Settings' ? 'active' : ''}`}
                onClick={() => setActive('Security Settings')}
              >
                Security Settings
              </li>
            )} */}
          </ul>
        </div>
      </div>

      {active === 'Profile Settings' && (
        <div className="col-sm-12 col-md-12 col-xl-9">
          <div className="viewSettign-main">
            <div
              className="edit-btn"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div>
                <HiBars3 className="open-sidebar-button" onClick={showOffcanvas} />
              </div>
              <div>
                {
                  props.loading ? (
                    <Skeleton className='badge rounded-pill' width={100} height={40} />
                  ) : (
                    <RoleWiseFeatureWrapper
                      modules={props?.modules}
                      features={props?.features}
                      user={props?.user}
                      ModuleName={ModulesList.Settings}
                      Featur_Name={FeaturesList.Update}>
                      <button
                        type="submit"
                        disabled={!isFormChanged}
                        className="custom-btn"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    </RoleWiseFeatureWrapper>
                  )
                }
              </div>
            </div>

            <div className="content-part">
              <div className="row">
                <div className="col-lg-12">
                  <div className="left-part">
                    <div className="custom-row">
                      <div className="project-detail">
                        <div className="settings-tab-buttons">
                          <div
                            className={`settings-tab-item ${activeTab === 'profile' ? 'active-tab' : ''
                              }`}
                          >
                            <button
                              className="settings-tab-link"
                              onClick={() => setActiveTab('profile')}
                            >
                              Profile
                            </button>
                          </div>
                        </div>

                        {activeTab === 'profile' && (
                          <div className="row profile-details">
                            <div className="col-lg-12">
                              {
                                props.loading ? (
                                  <Skeleton className='rounded-2' width="100%" height={200} />
                                ) : (
                                  <div className="input-group">
                                    <label className="label">
                                      Profile Picture
                                      <span style={{ color: 'red', fontSize: '0.9em', marginLeft: '8px' }}>
                                        (Max size: 2MB)
                                      </span>
                                    </label>
                                    <div className="file-upload-wrapper">
                                      <label htmlFor="file-upload" className="file-upload-label">
                                        {imagePreview || profilePic ? <img src={profilePic || imagePreview} height="130px" width="130px" /> : <FaCamera ircle size={100} color="rgb(180, 180, 180)" />}
                                      </label>
                                      <input
                                        type="file"
                                        id="file-upload"
                                        className="file-upload-input"
                                        name="photos"
                                        multiple
                                        onChange={handleFileChange}
                                      />
                                    </div>
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <>
                                    <h6 className="label" style={{ marginBottom: '16px' }}>
                                      Full Name
                                    </h6>
                                    <div className="custom-input-group">
                                      {/* <div style={{ flexShrink: 0 }}>
                                  <Select
                                    options={namePrefix}
                                    styles={{
                                      ...customStyle,
                                      container: (provided) => ({
                                        ...provided,
                                        width: '85px',
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 2,
                                      }),
                                    }}
                                    value={prefix}
                                    placeholder="---"
                                    onChange={(val) => {
                                      setNamePrefix(val);
                                    }}
                                    theme={(theme) => ({
                                      ...theme,
                                      colors: {
                                        ...theme.colors,
                                        primary25: '#5757fe',
                                        primary: '#5757fe',
                                      },
                                    })}
                                  />
                                </div> */}
                                      <input
                                        type="text"
                                        className="input-css"
                                        name="name"
                                        placeholder="Full Name"
                                        value={name}
                                        onChange={(e) => {
                                          setName(e.target.value)
                                        }}
                                      />
                                    </div>
                                  </>
                                )
                              }
                            </div>

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Personal Email</h6>
                                    <input
                                      type="email"
                                      className="input-css"
                                      name="personal_email"
                                      placeholder="Personal Email"
                                      value={personalEmail}
                                      onChange={(e) => {
                                        setPersonalEmail(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>
                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Company Email</h6>
                                    <input
                                      type="email"
                                      className="input-css"
                                      name="company_email"
                                      placeholder="Company Email"
                                      value={email}
                                      onChange={(e) => {
                                        setEmail(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>
                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Company Password</h6>
                                    <input
                                      type="text"
                                      className="input-css"
                                      name="projectname"
                                      placeholder="Company Password"
                                      value={password}
                                      onChange={(e) => {
                                        setPassword(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Skills</h6>
                                    <input
                                      type="text"
                                      className="input-css"
                                      name="skills"
                                      placeholder="Skills"
                                      value={skills}
                                      onChange={(e) => {
                                        setSkills(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            {/* <div className="col-lg-4">
                                <div className="input-group">
                                  <h6 className="label">Enable RTL Theme (Right to Left)</h6>
                                  <div className="form-check-groups">
                                    <div className="form-checks">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="rtl"
                                        id="Yes"
                                        value={rtl}
                                        onChange={(e) => setRtl(e.target.value)}
                                        defaultChecked={props?.user?.rtl ? true : false}
                                      />
                                      <label className="radio-label" htmlFor="Yes">
                                        Yes
                                      </label>
                                    </div>

                                    <div className="form-checks">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="rtl"
                                        id="No"
                                        value={rtl}
                                        onChange={(e) => setRtl(e.target.value)}
                                        defaultChecked={props?.user?.rtl ? false : true}
                                      />
                                      <label className="radio-label" htmlFor="No">
                                        No
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div> */}

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Mobile Number</h6>
                                    <input
                                      type="text"
                                      className="input-css"
                                      name="mobile"
                                      placeholder="Mobile"
                                      value={mobile}
                                      onChange={(e) => {
                                        setMobile(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-12">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Permanent Address</h6>
                                    <textarea
                                      rows="4"
                                      cols="50"
                                      className="form-control input-css"
                                      style={{ width: '100%' }}
                                      name="permanent_address"
                                      placeholder="Permanent Address"
                                      value={permanent_address}
                                      onChange={(e) => {
                                        setPermanentAddress(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-12">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Current Address</h6>
                                    <textarea
                                      rows="4"
                                      cols="50"
                                      className="form-control input-css"
                                      style={{ width: '100%' }}
                                      name="address"
                                      placeholder="Current Address"
                                      value={address}
                                      onChange={(e) => {
                                        setAddress(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            {/* <div className="col-lg-4">
                              <div className="input-group">
                                <h6 className="label">Country</h6>
                                {console.log(props?.user?.country)}
                                <Select
                                  options={Country}
                                  styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 2,
                                    }),
                                  }}
                                  value={country}
                                  onChange={(val) => {
                                    setCountry(val);
                                  }}
                                  theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#5757fe',
                                      primary: '#5757fe',
                                    },
                                  })}
                                />
                              </div>
                            </div>



                            <div className="col-lg-4">
                              <div className="input-group">
                                <h6 className="label">Change Language</h6>
                                <Select
                                  options={Language}
                                  styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 2,
                                    }),
                                  }}
                                  value={language}
                                  onChange={(val) => {
                                    setLanguage(val);
                                  }}
                                  theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#5757fe',
                                      primary: '#5757fe',
                                    },
                                  })}
                                />
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div className="input-group">
                                <h6 className="label">Gender</h6>
                                <Select
                                  options={Gender}
                                  styles={{
                                    ...customStyle,
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 2,
                                    }),
                                  }}
                                  value={gender}
                                  onChange={(val) => {
                                    setGender(val);
                                  }}
                                  theme={(theme) => ({
                                    ...theme,
                                    colors: {
                                      ...theme.colors,
                                      primary25: '#5757fe',
                                      primary: '#5757fe',
                                    },
                                  })}
                                />
                              </div>
                            </div> */}

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Date of Birth</h6>
                                    <DatePicker
                                      styles={customStyle}
                                      selected={dob ? new Date(dob) : null}
                                      placeholderText="Select Date"
                                      onChange={(date) => {
                                        setDOB(date);
                                      }}
                                      disabled={props.loading}
                                      dateFormat="dd-MM-yyyy"
                                      theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                          ...theme.colors,
                                          primary25: '#5757fe',
                                          primary: '#5757fe',
                                        },
                                      })}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className="label">Slack ID</h6>
                                    <input
                                      type="text"
                                      className="input-css"
                                      name="slackmemberid"
                                      placeholder="Enter Slack Member ID.."
                                      value={slack_id}
                                      onChange={(e) => {
                                        setSlackId(e.target.value)
                                      }}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            <div className="col-lg-4">
                              {
                                props.loading ? (
                                  <Skeleton />
                                ) : (
                                  <div className="input-group">
                                    <h6 className='label'>Marital Status</h6>
                                    <Select
                                      options={MaritalStatus}
                                      menuPlacement="top"
                                      styles={{
                                        ...customStyle,
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 2,
                                        }),
                                      }}
                                      value={maritalStatus}
                                      onChange={(val) => {
                                        setMaritalStatus(val)
                                      }}
                                      theme={(theme) => ({
                                        ...theme,
                                        colors: {
                                          ...theme.colors,
                                          primary25: "#5757fe",
                                          primary: "#5757fe",
                                        },
                                      })}
                                    />
                                  </div>
                                )
                              }
                            </div>

                            {maritalStatus?.value === "Married" ? (
                              <div className="col-lg-4">
                                {
                                  props.loading ? (
                                    <Skeleton />
                                  ) : (
                                    <div className="input-group">
                                      <h6 className='label'>Marriage Anniversary</h6>
                                      <DatePicker
                                        selected={anniversary ? new Date(anniversary) : null}
                                        onChange={(date) => setmrgAnniversary(date)}
                                        dateFormat="dd-MM-yyyy"
                                        name="transaction_date"
                                        placeholderText="Marriage Anniversary"
                                        className="w-full p-2 border rounded bg-white text-black"
                                        theme={(theme) => ({
                                          ...theme,
                                          colors: {
                                            ...theme.colors,
                                            primary25: "#5757fe",
                                            primary: "#5757fe",
                                          },
                                        })}
                                      />
                                    </div>
                                  )
                                }
                              </div>
                            ) : (
                              <></>
                              // <div className="col-lg-4">
                              //   <div className="input-group invisible">
                              //     <h6 className='label'>Marriage Anniversary</h6>
                              //     <input
                              //       type="text"
                              //       disabled
                              //       className="w-full p-2 border rounded bg-transparent"
                              //     />
                              //   </div>
                              // </div>
                            )}


                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {active === 'Security Settings' && (
        <div className="col-sm-12 col-md-12 col-xl-9">
          <div className="viewSettign-main">
            <div
              className="edit-btn"
              style={{ display: 'flex', justifyContent: 'space-between' }}
            >
              <div>
                <HiBars3 className="open-sidebar-button" onClick={showOffcanvas} />
              </div>

              {/* <div>
                <button
                  type="submit"
                  className="custom-btn me-3"
                  onClick={() => navigate('/employees')}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="custom-btn"
                  onClick={() => navigate('/employees')}
                >
                  Save
                </button>
              </div> */}
            </div>

            <div className="content-part">
              <div className="row">
                <div className="col-lg-12">
                  <div className="left-part">
                    <div className="custom-row">
                      <div className="project-detail">
                        <div className="settings-authentication-btn">
                          <div
                            className={`settings-tab-item ${activeSecurityTab === 'TwoFactorAuthentication' ? 'active-tab' : ''
                              }`}
                          >
                            <button
                              className="settings-tab-link"
                              onClick={() => setactiveSecurityTab('TwoFactorAuthentication')}
                            >
                              Two-Factor Authentication
                            </button>
                          </div>
                        </div>

                        <div className="row profile-details">
                          <div className="col-lg-12">
                            <div>
                              <div className="custom-row">
                                <Alert
                                  variant="filled"
                                  severity="error"
                                  style={{
                                    backgroundColor: '#E2E3E5',
                                    color: '#383D41',
                                    marginBottom: '20px',
                                  }}
                                  iconMapping={{
                                    error: <FaCircleInfo style={{ color: '#383D41' }} />,
                                  }}
                                >
                                  Increase your account's security by enabling Two-Factor
                                  Authentication (2FA)
                                </Alert>
                                <Alert
                                  variant="filled"
                                  severity="error"
                                  style={{
                                    backgroundColor: '#F6CCCC',
                                    color: '#6E0000',
                                  }}
                                  iconMapping={{
                                    error: <FaCircleInfo style={{ color: '#6E0000' }} />,
                                  }}
                                >
                                  Email SMTP settings not configured.
                                </Alert>

                                <div className="setup-email">
                                  <FaEnvelopeOpenText className="setup-email-icon" />
                                  <div>
                                    <h6 className="setup-heading">Setup Using Email</h6>
                                    <h6 className="setup-text">
                                      Enabling this feature will send code to your email account {props?.user?.email} for login.
                                    </h6>
                                  </div>
                                </div>

                                <div className="setup-email">
                                  <PiClockCountdownFill className="setup-email-icon" />
                                  <div>
                                    <h6 className="setup-heading">
                                      Setup Using Google Authenticator
                                    </h6>
                                    <h6 className="setup-text">
                                      Use the Authenticator app to get free verification codes,
                                      even when your phone is offline. Available for Android and
                                      iPhone.
                                    </h6>

                                    <div className="edit-btn">
                                      <button
                                        type="button"
                                        className="custom-btn"
                                        onClick={handleShow}
                                      >
                                        Enable
                                      </button>
                                    </div>

                                    <Modal
                                      show={showModal}
                                      onHide={handleClose}
                                      centered
                                      dialogClassName="custom-status-modal"
                                    >
                                      <Modal.Header closeButton>
                                        <Modal.Title className="custom-statusmodal-title">
                                          Authentication Required
                                        </Modal.Title>
                                      </Modal.Header>
                                      <Modal.Body className="custom-statusmodal-body">
                                        <div className="input-group">
                                          <h6 className="label">Your Password</h6>
                                          <input
                                            type="password"
                                            className="input-css"
                                            name="password"
                                            placeholder="Please enter your password"
                                          />
                                        </div>
                                      </Modal.Body>
                                      <Modal.Footer>
                                        <Button
                                          variant="secondary"
                                          onClick={handleClose}
                                          className="btn-cancel"
                                        >
                                          Cancel
                                        </Button>
                                        <Button
                                          variant="primary"
                                          onClick={handleClose}
                                          className="btn-confirm"
                                        >
                                          Confirm Password
                                        </Button>
                                      </Modal.Footer>
                                    </Modal>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.userReducer.loading,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    updateUsers: (id, data) => {
      dispatch(updateUsers(id, data))
    },
    deleteRecord: (id, inputValue) => {
      dispatch(deleteRecord(id, inputValue))
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Setting);
